/**
 * @module app.shared
 */


/***** TYPES *****/

// ReSharper disable once InconsistentNaming
export type ExtendBaseLocalState<T> = T & { _state?: IBaseLocalState; };

// ReSharper disable once InconsistentNaming
export type ExtendLocalState<T, TState> = T & { _state?: TState };


/***** INTERFACES *****/
export interface IBaseLocalState {
    isSelected?: boolean;
    isValid?: boolean | null;
}

export interface IEditable {
    isEditing?: boolean | null;
};

// Functions
export function applyLocalState<TExtended extends ExtendLocalState<T, TState>, T extends {}, TState extends {} = IBaseLocalState>(targets: readonly TExtended[], applyState: Partial<TState>, defaultState: TState): void {
    for(const target of targets) {
        // if(!target._state && defaultState) {
        //     target._state = {...defaultState};
        // }
        // if(target._state) {
        //     Object.assign(target._state, applyState);
        // }
        target._state = { ...defaultState, ...target._state, ...applyState };
    }
}
